import { httpClient } from "./Api";

const apiEndpoints = {
    login: "/auth/login",
    preAuth: "/auth/userPreAuth",
    verifiedUser: "/auth/verifiedUser",
};

const createHandler = (endpoint, login = false) => {

    return ( model, callbackFn = () => null) => {
        return httpClient.post(endpoint, model)
            .then(({ data }) => {
                if (callbackFn) callbackFn({ data: data, status: true });
            })
            .catch(error => {
                if (callbackFn) callbackFn({ data: error, status: false });
            });
    };
}

export const postLogin = createHandler(apiEndpoints.login)
export const postPreLogin = createHandler(apiEndpoints.preAuth);
export const postVerfiedUser = createHandler(apiEndpoints.verifiedUser)
